import React from 'react';
import './ResultadosParceirosSection.css';

const ResultadosParceirosSection = () => {
  return (
    <section className="resultados-parceiros-section">
      <div className="resultados-parceiros-content">
        <h2 className="resultados-parceiros-title">
          Resultados reais de parceiros
        </h2>
        
        <div className="resultados-parceiros-cards">
          <div className="resultado-card">
            <div className="resultado-value">+35%</div>
            <div className="resultado-label">Aumento em ocupação média</div>
          </div>
          
          <div className="resultado-card">
            <div className="resultado-value">+28%</div>
            <div className="resultado-label">Receita com serviços extras</div>
          </div>
          
          <div className="resultado-card">
            <div className="resultado-value">9,2/10</div>
            <div className="resultado-label">NPS entre parceiros</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResultadosParceirosSection;

